import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import back from "../../assets/back.svg";
import { superUserVersionDetails } from "../../redux/actions/superUserAction";
import "./superUsers.css";
import { JSONTree } from "react-json-tree";
import moment from "moment";
import LoadingSpinnerTable from "../../components/utilites/loader";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";

const SuperUserVersionHistoryView = () => {
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const [superUserVersionData, setSuperUserVersionData] = useState(null);
  const [superUserVesrionDetailOldData, setSuperUserVesrionDetailOldData] =
    useState(null);
  const [superUserVesrionDetailNewData, setSuperUserVesrionDetailNewData] =
    useState(null);
  const [vendorDivisions, setVendorDivisions] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    console.log(params?.id);
    dispatch(superUserVersionDetails(params?.id, onSuccess, onError));
  }, []);

  const onSuccess = (data) => {
    setLoading(false);
    console.log(data.data.data);
    setSuperUserVersionData(data.data.data);
    setSuperUserVesrionDetailOldData(data.data.data.vendorVersion.old_data);
    setSuperUserVesrionDetailNewData(data.data.data.vendorVersion.new_data);
  };
  const onError = (err) => {
    setLoading(false);
    console.log(err);
  };
  const theme = {
    scheme: "monokai",
    author: "wimer hazenberg (http://www.monokai.nl)",
    base00: "#272822",
    base01: "#383830",
    base02: "#49483e",
    base03: "#75715e",
    base04: "#a59f85",
    base05: "#f8f8f2",
    base06: "#f5f4f1",
    base07: "#f9f8f5",
    base08: "#f92672",
    base09: "#464646",
    base0A: "#f4bf75",
    base0B: "#464646",
    base0C: "#a1efe4",
    base0D: "#464646",
    base0E: "#ae81ff",
    base0F: "#cc6633",
    nestedKeyLabel: {
      fontSize: "14px",
    },
    value: {
      fontSize: "14px",
    },
  };

  const data = [
    {
      heading: "Company Employee ID",
      title: superUserVersionData?.employee_id
        ? superUserVersionData?.employee_id.charAt(0).toUpperCase() +
          superUserVersionData?.employee_id.slice(1)
        : "--",
    },
    {
      heading: "Name",
      title: superUserVersionData?.name
        ? superUserVersionData?.name.charAt(0).toUpperCase() +
          superUserVersionData?.name.slice(1)
        : "--",
    },
    {
      heading: "Email Address",
      title: superUserVersionData?.email ? superUserVersionData?.email : "--",
    },
    {
      heading: "Phone Number",
      title: superUserVersionData?.mobile
        ? `+91 ${superUserVersionData?.mobile}`
        : "--",
    },
    {
      heading: "Division",
      title: superUserVersionData?.superUserDivisions?.map((ele, index) => {
        return (
          <span key={index}>
            {index ? <span className="mx-1 color_b0b3c7">|</span> : ""}
            {ele?.vendorDivision?.name}
          </span>
        );
      }),
    },
    {
      heading: "Updated By",
      title: superUserVersionData?.vendorVersion?.updatedByVendor?.name
        ? superUserVersionData?.vendorVersion?.updatedByVendor?.name
            .charAt(0)
            .toUpperCase() +
          superUserVersionData?.vendorVersion?.updatedByVendor?.name.slice(1)
        : "--",
    },
    {
      heading: "Updated Date",
      title: superUserVersionData?.vendorVersion?.updatedAt
        ? moment(superUserVersionData?.vendorVersion?.updatedAt).format(
            "DD MMM YYYY HH:mm A"
          )
        : "--",
    },
  ];
  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/super-user/user",
      breadcrumb: " / super users",
    },

    {
      path: "/super-user/user/version-history-detail/:id",
      breadcrumb: superUserVersionData?.employee_id
        ? ` / ${superUserVersionData?.employee_id} - version history`
        : " / version history",
    },
  ];
  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });
  return (
    <>
      <div className="products-page">
        <div className="products-main-div">
          <div className="mx-3">
            {breadcrumbs.map(({ match, breadcrumb }) => (
              <NavLink
                key={match.pathname}
                to={match.pathname}
                className="header-route-page fw_400 cursor_pointer"
              >
                <span className="fs_18">{breadcrumb}</span>
              </NavLink>
            ))}
          </div>
          <div className="products-main-list my-2 py-1">
            <div className="search-container d-flex justify-content-between ">
              <div
                className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                onClick={() => navigate(-1)}
              >
                <img src={back} alt="back_btn" />
                <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                  BACK
                </span>
              </div>
            </div>
            <div style={{ position: "relative" }}>
              {loading == true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : (
                <>
                  <div className="pt-3  mx-2 row">
                    {data.map((item, index) => (
                      <div className="mb-2 col-4 col-sm-3 col-xl label-conatiner mx-3 ms-4 mx-xl- pe-xl-0 pe-5">
                        <h5 className="color_b0b3c7 text-nowrap fs_15 fw_500 m-0">
                          {item.heading}
                        </h5>
                        {item.heading === "Email Address" ? (
                          <p
                            className={`fs_15 fn_Nunito fw_500 color_262c3d text-truncate col-lg-10 email-slice `}
                            title={item.title}
                          >
                            {item.title}
                          </p>
                        ) : item.heading === "Division" ? (
                          <p
                            className={`fs_15 fn_Nunito fw_500 color_262c3d text-truncate col-lg-10 email-slice  `}
                          >
                            {item.title}
                          </p>
                        ) : (
                          <p className={` fs_16 fn_Nunito text-nowrap fw_600 `}>
                            {item.title}
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                  <div className=" mx-3 d-none d-xl-block form-sub-details my-3 mb-4">
                    <div className="d-flex justify-content-between">
                      <div className="col-5 mx-4 ">JSON Old Data</div>
                      <div className="col-6">
                        <span className="ms-4 ps-2">JSON New Data</span>
                      </div>
                    </div>
                  </div>
                  <div className="d-xl-flex flex-column flex-md-row justify-content-between col-xl-11 gap-xxl-4 mt-5 mt-xl-0">
                    <div
                      className="col-10 col-xl-6 my-2 mx-auto mx-xl-3 px-xl-2 ms-xl-4 ps-xl-3"
                      style={{ minHeight: "30rem" }}
                    >
                      <div>
                        <h6
                          className="px-3 py-3 my-auto"
                          style={{
                            backgroundColor: "#E7E5FF",
                            borderTopLeftRadius: "10px",
                            borderTopRightRadius: "10px",
                          }}
                        >
                          Old Data
                        </h6>
                        <div className="">
                          <div className="admin_aprvls_vrsn_hstry_data_container  mt-3 pt-3 px-3">
                            <>
                              {superUserVesrionDetailOldData === null ? (
                                <>Empty data</>
                              ) : (
                                <>
                                  <JSONTree
                                    theme={theme}
                                    data={superUserVesrionDetailOldData}
                                  />
                                  ;
                                </>
                              )}
                            </>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="col-10 col-xl-6 my-2 mx-xl-3 mx-auto"
                      style={{ minHeight: "30rem" }}
                    >
                      <div>
                        <h6
                          className="px-3 py-3 my-auto"
                          style={{
                            backgroundColor: "#E7E5FF",
                            borderTopLeftRadius: "10px",
                            borderTopRightRadius: "10px",
                          }}
                        >
                          New Data
                        </h6>
                        <div className="">
                          <div className="admin_aprvls_vrsn_hstry_data_container  mt-3 pt-3 px-3">
                            <>
                              {superUserVesrionDetailNewData === null ? (
                                <>Empty data</>
                              ) : (
                                <>
                                  <JSONTree
                                    theme={theme}
                                    data={superUserVesrionDetailNewData}
                                  />
                                  ;
                                </>
                              )}
                            </>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuperUserVersionHistoryView;

const newData = [
  {
    heading: "Checker Id",
    title: "adminVersionData?.id",
  },
  {
    heading: "Name",
    title: "adminVersionData?.new_data?.[0]?.name",
  },
  {
    heading: "Admin Id",
    title: "adminVersionData?.new_data?.[0]?.admin_id",
  },
  {
    heading: "Approved By",
    title:
      "adminVersionData?.new_data?.[0]?.approved_by === null ? " -
      " : adminVersionData?.new_data?.[0]?.approved_by,",
  },
  {
    heading: "Approved Date",
    title: "sfsdfdf",
  },
  {
    heading: "Updated Date",
    title: "sfcsdvdsvc",
  },
  {
    heading: "Updated By",
    title: "cvcxvcxvcx",
  },
];
const oldData = [
  {
    heading: "Checker Id",
    title: "adminVersionData?.id",
  },
  {
    heading: "Name",
    title: "adminVersionData?.old_data?.name",
  },
  {
    heading: "Role Id",
    title: "adminVersionData?.old_data?.role_id",
  },
  {
    heading: "Name",
    title: "adminVersionData?.old_data?.name",
  },
  {
    heading: "Email",
    title: "adminVersionData?.old_data?.email",
  },
  {
    heading: "Admin Id",
    title: "adminVersionData?.old_data?.id",
  },

  {
    heading: "Approved Date",
    title: "dgfvgfdcbcv",
  },
  {
    heading: "Updated Date",
    title: "gsfgdgdfgdf",
  },
];
